import React from 'react';

function Services() {
  return (
    <section id="services" aria-labelledby="services-label">

      {/* === CORE EXPERTISE === */}
      <div className="services-heading revealable">
        <h2 id="services-label">Expertise</h2>
      </div>

      <p>
        Applied financial capabilities developed through hands-on analysis, modeling,
        and decision support across strategic finance and investment contexts.
      </p>

      <div className="service-grid revealable">
        <div className="service-card from-left delay-1">
          <h3>Strategic Finance & FP&A</h3>
          <p>
            Supporting leadership teams with budgeting, forecasting, performance
            tracking, and variance analysis to inform capital allocation and long-term planning.
          </p>
        </div>

        <div className="service-card from-right delay-2">
          <h3>Mergers & Acquisitions (M&A)</h3>
          <p>
            Providing analytical support across the transaction lifecycle including
            valuation, due diligence, and investment decision-making.
          </p>
        </div>

        <div className="service-card from-left delay-1">
          <h3>Financial Modeling & Valuation</h3>
          <p>
            Building robust financial models for valuation, forecasting, scenario
            analysis, and strategic planning.
          </p>
        </div>

        <div className="service-card from-right delay-2">
          <h3>Portfolio & Investment Analysis</h3>
          <p>
            Analyzing portfolio performance, risk metrics, and market exposure to
            support disciplined investment decisions.
          </p>
        </div>
      </div>

      {/* === TOOLS & CAPABILITIES === */}
      <div className="services-heading revealable" style={{ marginTop: "60px" }}>
        <h2>Tools & Capabilities</h2>
      </div>

      <p className="tools-subtext">
        Technical and analytical tools used across modeling, automation, valuation,
        and decision support.
      </p>

      <div className="tools-grid revealable">

        {/* Card 1 */}
        <div className="tool-card">
          <div className="tool-card-inner">
            <div className="tool-card-front">
              <h3>Financial Modeling</h3>
              <span className="flip-hint">Flip to see skills</span>
            </div>
            <div className="tool-card-back">
              <ul>
                <li>Advanced Excel financial models (3-statement, forecasting)</li>
                <li>Budgeting, planning, and variance analysis</li>
                <li>Scenario and sensitivity analysis</li>
                <li>Model design for management and internal decision-making</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Card 2 */}
        <div className="tool-card">
          <div className="tool-card-inner">
            <div className="tool-card-front">
              <h3>Valuation & Investment Analysis</h3>
              <span className="flip-hint">Flip to see skills</span>
            </div>
            <div className="tool-card-back">
              <ul>
                <li>DCF valuation and assumption design</li>
                <li>Comparable company & transaction analysis</li>
                <li>Investment evaluation and capital allocation analysis</li>
                <li>Sensitivity and downside risk assessment</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Card 3 */}
        <div className="tool-card">
          <div className="tool-card-inner">
            <div className="tool-card-front">
              <h3>Data & Analytics</h3>
              <span className="flip-hint">Flip to see skills</span>
            </div>
            <div className="tool-card-back">
              <ul>
                <li>Python for financial analysis (Pandas, NumPy)</li>
                <li>Data automation, cleaning, and structuring</li>
                <li>Dashboards & executive visualization (Streamlit, Power BI, Tableau)</li>
                <li>Time-series analysis and trend identification</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Card 4 */}
        <div className="tool-card">
          <div className="tool-card-inner">
            <div className="tool-card-front">
              <h3>Executive Communication & Decision Support</h3>
              <span className="flip-hint">Flip to see skills</span>
            </div>
            <div className="tool-card-back">
              <ul>
                <li>Management, investment and pitch presentations (PowerPoint)</li>
                <li>Investment memos and decision briefs</li>
                <li>Structuring financial insights for senior stakeholders</li>
                <li>Story-driven communication of complex analysis</li>
              </ul>
            </div>
          </div>
        </div>

      </div>

    </section>
  );
}

export default Services;